import api from 'base/utils/api';
import { filterFields } from 'ava-util/dist/data';
import { filterProductFields, filterProductsFields } from 'base/utils/product';
import { IProduct } from 'base/interfaces/product';
import {
    ITopStripedBanner,
    ITopPromotionBar,
    IGetListFeatureConfig,
    IHomePageVideoPopup,
    IFloatMiniEntrance, ITagTheme
} from 'base/interfacesV2/feature';
import {
    IFeature,
    bannerTypes,
    productListTypes
} from 'mod/feature/interface';
import { THomePageVersion } from 'base/store/serverStore';

const validTypes = [
    ...bannerTypes,
    ...productListTypes,
    'pageList',
    'navigation',
    'gridNav',
    'blog',
    'SuperFlashSale',
]

// 页头活动条幅
export function getTopStripedBanner(): Promise<ITopStripedBanner> {
    return api.get('/web/featureConfig/getTopStripedBanner', {
        params: {
            name: process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 'CountdownH5' : 'CountdownPC'
        }
    });
}

// 页头下方文字宣传栏
export function getTopPromotionBar(): Promise<ITopPromotionBar> {
    return api.get('/web/featureConfig/getHomeTopBanner', {
        params: {
            name: process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 'h5_top' : 'pc_top',
        }
    });
}

// tag theme 标签主题
export function getTagTheme(): Promise<ITagTheme> {
    return api.get('/web/featureConfig/tags/theme', {
        params: {}
    }).catch(err => {
        return {}
    });
}

export function getHomeFeatureList(mock: any): Promise<IFeature[]> {
    const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';
    const apiUrl = mock && process.env.NEXT_PUBLIC_ENV_NAME !== 'prod' ? '/api/featureConfig/getHomePageConfig' : '/web/featureConfig/getHomePageConfig';
    return api.get(apiUrl, {
        params: {
            name: isPhone ? 'homePageH5_03' : 'homePagePc_03',
            kind: isPhone ? 'feature_homepage_h5' : 'feature_homepage_pc',
        }
    }).then((res: IFeature[]) => {
        const list: IFeature[] = [];
        res.forEach(feature => {
            const { type } = feature;
            // 过滤无效type和空列表
            if (feature.lists.length === 0) {
                return;
            }

            // @ts-ignore
            let keepFields = [
                'type',
                'moduleId',
                'lists',
                'title',
                'readMoreTitle',
                'readMoreLink',
                'endTimeStamp',
                'space',
                'background',
                'config',
            ];
            const _feature = filterFields(feature, keepFields);

            // @ts-ignore
            if (productListTypes.includes(type)) {
                _feature.lists = filterProductsFields(feature.lists as IProduct[]);
            } else if (type === 'superFlashSale') {
                _feature.lists = _feature.lists.map((item: any) => ({
                    ...item,
                    variant: filterProductFields(item.variant)
                }));
            }

            list.push(_feature);
        });
        return list;
    });
};


/**
 * 获取列表feature配置
 */
export function getListFeatureConfig(params: IGetListFeatureConfig): Promise<IFeature[]> {
    return api.get(
        '/web/featureConfig/getListFeatureConfig',
        {
            params
        }
    )
}

/**
 * 获取详情页feature配置
 */
export function getDetailFeatureConfig(params: IGetListFeatureConfig): Promise<IFeature[]> {
    return api.get(
        '/web/featureConfig/getDetailFeatureConfig',
        {
            params
        }
    )
}

/**
 * 获取首页弹窗配置
 */
export function getHomePageVideoPopup(): Promise<IHomePageVideoPopup | null> {
    return api.get('/web/featureConfig/getHomePageVideoPopup', {
        params: {
            name: process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 'H5' : 'PC',
        }
    })
}

/**
 * 获取首页左下角浮动活动入口
 */
export function getFloatMiniEntrance(): Promise<IFloatMiniEntrance> {
    return api.get('/web/featureConfig/getFloatingWindow')
}

/**
 * 获取首页版本配置
 */
export function getHomeVersion(): Promise<THomePageVersion> {
    return api.get('/web/featureConfig/homepage/version').then(res => res.version).catch(() => 'OLD')
}
